import Dexie from "dexie"

// Single Dexie instance for the WIN Chat App offline store.
// Import this from any Stimulus controller or module that needs offline storage.
//
// Tables:
//   cached_chats       -- all chats the user is a participant in
//   cached_messages    -- last 50 messages per chat
//   cached_participants -- participants per chat (for group chat details)
//   outbox             -- messages queued for sending while offline

const db = new Dexie("ChatDatabase")

db.version(1).stores({
  // Chat list cache. Keyed by server Chat#id.
  // last_message_at: for sorting. chat_type: 'direct_message' | 'group_chat'.
  cached_chats: "id, chat_type, last_message_at, updated_at",

  // Message cache. Compound index on [chat_id+created_at] for efficient
  // per-chat ordered retrieval.
  cached_messages: "id, [chat_id+created_at], chat_id, created_at",

  // Participant cache. chat_id + user_id for membership lookups.
  cached_participants: "id, chat_id, user_id",

  // Outbox: messages queued while offline. Auto-incremented local id.
  // chat_id: target chat. retry_count: incremented on send failure.
  // status: 'pending' | 'syncing' | 'failed'
  outbox: "++id, chat_id, created_at, status"
})

db.version(2).stores({
  cached_chats: "id, chat_type, last_message_at, updated_at",
  cached_messages: "id, [chat_id+created_at], chat_id, created_at",
  cached_participants: "id, chat_id, user_id",
  outbox: "++id, chat_id, created_at, status",
  // Diagnostic log -- same schema as field_log
  chat_log: "++id, level, category, timestamp"
})

db.version(3).stores({
  // Renamed chat_log -> app_log for shared PWA logging.
  chat_log: null,
  app_log: "++id, level, category, timestamp"
}).upgrade(tx =>
  tx.table("chat_log").toCollection().modify(function () {
    tx.table("app_log").add(this.value)
    delete this.value
  })
)

export default db
